import { Typography } from '@mui/material';
import { compact } from 'lodash';
import React, { Fragment, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TradeMethodTreeSelect } from 'components';
import { TranslationNamespace } from 'i18n';

type Props = {
  fiatCurrencyId?: string;
};

export const ShopPayoutTradeMethods: React.FC<Props> = ({ fiatCurrencyId }) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.shops.manage',
  });
  const { t: tCommon } = useTranslation();

  const fiatCurrenciesIds = useMemo(
    () => compact([fiatCurrencyId]),
    [fiatCurrencyId],
  );

  return (
    <Fragment>
      <Typography variant="subtitle1">
        {`${t('sections.trade_methods.title')} (${tCommon('common.payout')})`}
      </Typography>

      <TradeMethodTreeSelect
        fieldName={'payoutTradeMethodsConfigs'}
        fieldValueIdPropertyName={'tradeMethodId'}
        fiatCurrenciesIds={fiatCurrenciesIds}
      />
    </Fragment>
  );
};
